import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  commonZH, commonEN, commonJA,
  staticContentZH, staticContentEN, staticContentJA,
  modalZH, modalEN, modalJA,
  dataIOZH, dataIOEN, dataIOJA,
  resourceLimitZH, resourceLimitEN, resourceLimitJA
} from '@redpanda/common-locales';
import { deepMerge, mergeTranslations, createI18nInitConfig } from '@redpanda/utils';

// 本地翻譯檔案
import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import jaTranslation from './locales/ja/translation.json';
import enManual from './locales/en/manual.json';
import zhManual from './locales/zh/manual.json';
import jaManual from './locales/ja/manual.json';
import enStaticContentLocal from './locales/en/static-content.json';
import zhStaticContentLocal from './locales/zh/static-content.json';
import jaStaticContentLocal from './locales/ja/static-content.json';
import enPages from './locales/en/pages.json';
import zhPages from './locales/zh/pages.json';
import jaPages from './locales/ja/pages.json';

const resources = {
  en: {
    translation: mergeTranslations(commonEN, enTranslation),
    manual: enManual,
    staticContent: deepMerge(staticContentEN, enStaticContentLocal),
    modal: modalEN,
    dataIO: dataIOEN,
    resourceLimit: resourceLimitEN,
    pages: enPages,
  },
  zh: {
    translation: mergeTranslations(commonZH, zhTranslation),
    manual: zhManual,
    staticContent: deepMerge(staticContentZH, zhStaticContentLocal),
    modal: modalZH,
    dataIO: dataIOZH,
    resourceLimit: resourceLimitZH,
    pages: zhPages,
  },
  ja: {
    translation: mergeTranslations(commonJA, jaTranslation),
    manual: jaManual,
    staticContent: deepMerge(staticContentJA, jaStaticContentLocal),
    modal: modalJA,
    dataIO: dataIOJA,
    resourceLimit: resourceLimitJA,
    pages: jaPages,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(createI18nInitConfig({ resources }));

export default i18n;
